import React, {Component} from 'react';
import {
    Link
} from 'react-router-dom'
import {GetEntityAttribute} from "../Helpers/Entity";

export default class Breadcrumb extends Component {
    constructor(props) {
        super(props);
        this.triggerClickHandler = this.triggerClickHandler.bind(this);
    }

    render() {
        let items = this.props.items || [];
        let isClickAble = this.props.isClickable || false;
        let className = this.props.className ? this.props.className : '';
        className += ' Breadcrumb ';

        return <div className={className}>
            <div className="Breadcrumb--prefix">{this.props.prefix || ''}</div>
            <ul>
                {items.map((item, index) => {
                    if (isClickAble && item.url.length > 0) {
                        return (
                            <li key={index}><Link onClick={(e) => {
                                this.triggerClickHandler(e, item);
                            }} to={item.url}>{GetEntityAttribute(item,'title')}</Link></li>
                        );
                    }
                    return (
                        <li key={index} onClick={(e) => {
                            this.triggerClickHandler(e, item);
                        }}>{GetEntityAttribute(item,'title')}</li>
                    );
                })}
            </ul>
        </div>;
    }

    triggerClickHandler(e, item) {
        if (typeof  this.props.onClickHandler === 'function') {
            return this.props.onClickHandler(e, item);
        }
    }

}
